import React, {Component} from 'react';
import Parallax from "parallax-js";

const images = {
    society: ['phone', 'ball1', 'food', 'camera', 'laptop', 'pad', 'bacteria', 'grain'],
    education: ['books', 'ball2', 'ball3', 'ball4', 'ball5', 'ball1', 'laptop', 'pad', 'phone'],
    technology: ['jeep', 'engine', 'asteroids', 'laptop', 'mars', 'pad', 'phone'],
    environment: ['planet', 'bees', 'food', 'grain', 'helix', 'vessel']
};

export default class QuestionBackgroundElement extends Component {
    constructor(props) {
        super(props);

        this.categoryImages = images[this.props.category];
        this.state = {
            randomImages: []
        }
    }

    componentDidMount() {
        this.getRandomImages();
        this.backgroundAnimation();
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedQuestion !== prevProps.selectedQuestion) {
            this.getRandomImages();
        }
    }


    backgroundAnimation() {
        // const bg = document.getElementById('animate_question_bg')[0];
        const parallax2 = new Parallax(this.bg, {
            relativeInput: true,
        });
    }

    getRandomImages() {
        const randomImage = this.categoryImages[this.getRandomIndex(2, this.categoryImages.length - 1)];

        this.setState({ randomImage: randomImage });
    }

    getRandomIndex(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    }

    render() {
        return (
            <div className="question__background" ref={el => this.bg = el}>
                <div data-depth="0.1">
                    <img src={`../img/content/${this.props.category}/${this.categoryImages[0]}.png`} className={`image img--0`} />
                </div>
                <div data-depth="0.2">
                    <img src={`../img/content/${this.props.category}/${this.categoryImages[1]}.png`} className={`image img--1`} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./sources/js/components/Question/QuestionBackgroundElements.js